import $ from 'jquery';

export default function mNav (trigger, triggerActive, target, targetActive) {
    $(trigger).on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass(triggerActive)
			.attr('aria-expanded', function (i, attr) {
    			return attr == 'true' ? 'false' : 'true'
    		});
		$(target).toggleClass(targetActive);
	});
	$(window).on('load resize', function(e) {
        if ($( window ).width() > 900) {
            $(trigger).attr('aria-expanded', 'true');
          }
          if ($(window).width() <= 900) {
            $(trigger).attr('aria-expanded', 'false' );
          }
    });
}
